import { Input } from 'antd';
import MaskedInput from 'antd-mask-input';
import styled from 'styled-components';

export const Label = styled.span`
  color: #fafafa;
`;

export const CustomInput = styled(Input)`
  border: 2px solid transparent;

  &:disabled {
    background: lightgray;
  }

  &.msg-error {
    border: 2px solid red;
  }
`;

export const CustomMaskedInput = styled(MaskedInput)`
  border: 2px solid transparent;

  &:disabled {
    background: lightgray;
  }

  &.msg-error {
    border: 2px solid red;
  }
`;

export const WrapperLoading = styled.div`
  display: flex;
  // width: 100%;
  justify-content: center;
  padding-top: 30px;
`;
